import { StopCircle } from "@mui/icons-material";
import { styled } from "@mui/material";

const PulsatingStopCircle = styled(StopCircle)(({ theme }) => ({
  color: theme.palette.error.main,
  transition: theme.transitions.create("color", {
    duration: theme.transitions.duration.standard,
    easing: theme.transitions.easing.easeInOut,
  }),
  animation: `pulsate 2s infinite ${theme.transitions.easing.easeInOut}`,
  "@keyframes pulsate": {
    "0%": {
      color: theme.palette.error.light,
    },
    "50%": {
      color: theme.palette.error.dark,
    },
    "100%": {
      color: theme.palette.error.light,
    },
  },
}));

export default PulsatingStopCircle;
